




























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { Vat, EntityStatus, Product, Site, ProductAccessory, SimproJobDetails } from '@/api';

import EntityPagination from '@/components/EntityPagination.vue';
import { VatDashboard } from './models/vat-dashboard';
import MilkVatDetail from './MilkVatDetail.vue';
import MilkVatsOverview from './MilkVatsOverview.vue';
import { ProductAccessoryService } from '@/services/product-accessory-service';

@Component({
	components: {
		EntityPagination,
		MilkVatDetail,
		MilkVatsOverview,
	},
})
export default class VatsTab extends Vue {
	@Prop({ required: true, type: Object })
	public readonly product!: Product & { site: Site | null };

	@Prop({ required: true, type: Array })
	public readonly vats!: Vat[];

	@Prop({ required: true, type: Array })
	public readonly vatDashboards!: VatDashboard[];

	@Prop({ required: false, type: String })
	public readonly initialVatId: string | undefined;

	@Prop({ required: false, type: Array })
	public readonly accessories: ProductAccessory[] | undefined;

	@Prop({ required: false, type: Array })
	public readonly accessoriesForInstall: ProductAccessory[] | undefined;

	@Prop({ required: false, type: Array })
	public readonly simproJobs?: SimproJobDetails[];

	@Watch('currentPage')
	public onPageChanged(newPageIndex: number): void {
		const newVatIndex = this.vats[newPageIndex - 2]?.id?.toString();
		this.$router.replace({
			name: newVatIndex ? 'products.milk.vat' : 'products.milk.view',
			params: {
				productId: this.$route.params.productId,
				vatId: newVatIndex,
			},
		});
	}

	public currentPage: number = this.initialPageIndex(this.vats);

	public get selectedVat(): Vat | null {
		// Current page is not zero-indexed
		if (this.currentPage === 1) {
			return null;
		}
		return this.vats[this.currentPage - 2] ?? null;
	}

	public get site(): Site | null {
		return this.product.site;
	}

	public get selectedVatDashboard(): VatDashboard | null {
		if (this.currentPage === 1) {
			return null;
		}
		return this.vatDashboards[this.currentPage - 2] ?? null;
	}

	public paginationText(vat: Vat): string {
		return vat.label ?? 'No Vat Label';
	}

	public badgeColor(vat: Vat): string {
		if (vat.status === EntityStatus.Live) {
			return 'success';
		} else if (vat.status === EntityStatus.Cancelled || vat.status === EntityStatus.Removed) {
			return 'danger';
		} else {
			return 'warning';
		}
	}

	public badgeText(vat: Vat): string {
		return Vue.filter('titleCase')(vat.status ?? 'No status');
	}

	public onOverviewVatClicked(index: number): void {
		// Zero based index.
		this.currentPage = index + 2;
	}

	private initialPageIndex(vats: Vat[]): number {
		// Vue bootstrap pagination is NOT zero indexed.
		if (this.initialVatId !== undefined) {
			const vatId: number = parseInt(this.initialVatId, 10);
			if (!isNaN(vatId)) {
				const vatIndex = vats.findIndex((vat: Vat) => vat.id === vatId);
				if (vatIndex) {
					return vatIndex + 2;
				}
			}
		}
		const firstLiveVatIndex = vats.findIndex((vat: Vat) => vat.status === EntityStatus.Live);
		if (firstLiveVatIndex === -1) {
			return 1;
		}
		return firstLiveVatIndex + 2;
	}
}
